import React from 'react';
import PropTypes from 'prop-types';
import { RadioContent, StyledLabel } from './styles/AccessControlRadioStyles';

/**
 * アクセス制御のON/OFFを切り替えるラジオボタン
 * @param {Object} props
 * @param {boolean} props.isEnabled - アクセス制御がONかどうか
 * @param {string} props.labelText - ラベルのテキスト
 * @param {function} props.onRadioChange - ラジオボタンが変更されたときのコールバック
 * @returns
 */
const AccessControlRadio = ({ isEnabled, labelText, onRadioChange }) => {
  const isRadioButtonSelected = () =>
    (labelText === 'ON' && isEnabled) || (labelText === 'OFF' && !isEnabled);

  return (
    <RadioContent>
      <input
        type="radio"
        name="access"
        value
        checked={isRadioButtonSelected()}
        onChange={onRadioChange}
      />
      <StyledLabel>{labelText}</StyledLabel>
    </RadioContent>
  );
};

AccessControlRadio.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  labelText: PropTypes.string.isRequired,
  onRadioChange: PropTypes.func.isRequired,
};

export default AccessControlRadio;
